module.exports = "/images/severe-thunderstorm-warning@3x.png?a9ca7160ee34e548246ae2580ac5900b";